<template>
  <div class="record-detail">
    <section class="header">
      <h2>请假详情</h2>
      <div class="people-bar">
        <div class="bar">
          <span class="name">{{name}}</span>
          <img :src="icon" class="avatar" alt="avatar">
          <span class="status">{{status}}</span>
        </div>
      </div>
    </section>
    <ul class="item-list">
      <li class="item">
        <span class="item-name">请假类型：</span>
        <span class="item-value">{{leaveTypeName}}</span>
      </li>
      <li class="item">
        <span class="item-name">申请时间：</span>
        <span class="item-value">{{createdDate}}</span>
      </li>
      <li class="item">
        <span class="item-name">请假时间：</span>
        <span class="item-value">{{startTime}}</span>至<br>
        <span class="item-value" style="margin-left: 82px; padding-top: 10px">{{endTime}}</span>
      </li>
      <li class="item">
        <span class="item-name">请假图片：</span>
        <span class="item-value">{{leaveImg}}</span>
      </li>
      <li class="item">
        <span class="item-name">申请人：</span>
        <span class="item-value">抄送人</span>
      </li>
      <li class="item">
        <span class="item-name">抄送人：</span>
        <span class="item-value" v-for="item in ccArr" :key="item.Describe">{{item.Describe}}</span>
      </li>
      <li class="item" style="display: flex" v-if="originPage !== 'student'">
        <span class="item-name">审批结果：</span>
        <van-radio-group style="display: flex" v-model="approvalResult" :disable="role !== 'teacher'">
          <van-radio :name="2">同意</van-radio>
          <van-radio :name="3" style="margin-left: 30px">拒绝</van-radio>
        </van-radio-group>
      </li>
      <li class="item">
        <van-field
          style="height: 100px"
          clearable
          required
          type="textarea"
          label="审批意见"
          :maxlength="100"
          placeholder="审批意见"
          :disabled="originPage === 'student'"
          v-model="desc">
        </van-field>
      </li>

    </ul>
    <TwoBottomBtn v-if="originPage !== 'student'" @cancelClick="cancel" @confirmClick="confirm"></TwoBottomBtn>
  </div>
</template>
<script>
  import TwoBottomBtn from '../../components/TwoBottomBtn'
  import {Notify} from 'vant';

  const cardImgUrl = require('@/assets/attendance/yrykb.png');

  export default {
    name: 'StudentLeaveSubRecordDetail',
    data() {
      return {
        icon: '',
        ccArr: [],
        status: '',
        name: '',
        createdDate: '',
        startTime: '',
        endTime: '',
        leaveImg: '',
        substituteName: '',
        desc: '',
        leaveTypeName: '',
        approvalResult: '',
        role: '',
        leaveApplicationID: '',
        originPage:'',
      }
    },
    components: {
      TwoBottomBtn
    },
    created() {
      let queryParams = this.$route.query;
      this.status = queryParams.status;
      this.name = queryParams.name;
      this.createdDate = queryParams.createdDate;
      this.startTime = queryParams.startTime;
      this.endTime = queryParams.endTime;
      this.leaveImg = queryParams.LeavePermitSrc;
      this.substituteName = queryParams.substituteName;
      this.desc = queryParams.desc;
      this.leaveTypeName = queryParams.leaveTypeName;
      this.originPage = queryParams.originPage;
      this.icon = queryParams.icon ? queryParams.icon : cardImgUrl;
      this.role = queryParams.role ? queryParams.role : '';
      console.log(queryParams)
      this.leaveApplicationID = queryParams.LeaveApplicationID
    },
    mounted() {
      this.getCC()
    },
    methods: {
      async getCC() {
        let res = await this.xyapi.get(this.$store.state.apiPath + '/api/StudentLeaveMb/GetLeaveSetting');
        if (res.success) {
          this.ccArr = res.data.filter(function (value) {
            return value.LeaveSettingType === "CC" && value.IsEnabled
          })
        } else {
          Notify({type: 'danger', message: res.msg});
        }

      },
      cancel() {
        console.log('cancel')
      },

      async confirm() {
        if (this.approvalResult !== 2 && this.approvalResult !== 3) {
          Notify({type: 'danger', message: '请选择审批结果'});
          return
        }
        if (!this.desc) {
          Notify({type: 'danger', message: '请填写审核意见'});
          return;
        }
        let params = {
          LeaveApplicationID: this.leaveApplicationID,
          DeniedDescription: this.desc,
          ApproveStatus: this.approvalResult,
        }

        let res = await this.xyapi.post(this.$store.state.apiPath + '/api/StudentLeaveMb/EditState', params);
        if (res.success) {
          Notify({type: 'success', message: res.data});
        } else {
          Notify({type: 'danger', message: res.msg});
        }
      },


    },
  }
</script>
<style lang="less" scoped>
  .record-detail {
    padding-bottom: 40px;

    .header {
      height: 312px;
      background-image: url("../../../../assets/attendance/detail-bg.png");
      background-repeat: no-repeat;
      background-position: 0 0;
      background-size: 100% 222px;

      h2 {
        font-size: 32px;
        color: #ffffff;
        text-align: center;
        padding-top: 10px;
      }

      .bar {
        margin-left: 49px;
        margin-right: 49px;
        background: #fff;
        box-shadow: 0px 2px 18px 0px rgba(179, 199, 242, 0.54);
        border-radius: 12px;
        height: 138px;
        margin-top: 121px;
        padding: 0 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;

        .avatar {
          position: absolute;
          top: -100px;
          left: 50%;
          width: 152px;
          height: 152px;
          box-sizing: border-box;
          border-radius: 50%;
          border: 12px solid #ffffff;
          transform: translateX(-50%);
        }

        .name {
          font-size: 32px;
          color: #333333;
        }

        .status {
          width: 133px;
          height: 46px;
          background: linear-gradient(90deg, rgba(74, 152, 253, 1) 0%, rgba(124, 148, 252, 1) 100%);
          border-radius: 23px;
          color: #ffffff;
          font-size: 26px;
          text-align: center;
          line-height: 46px;
        }
      }
    }

    .item-list {
      background: #fff;
      margin-top: 50px;
      font-size: 28px;
      padding: 40px 20px;

      .item {
        padding-top: 50px;

        .item-name {
          color: #999;
        }

        .item-value {
          color: #333333;
          margin-left: 10px;
        }
      }
    }
  }
</style>
